import styled, { css } from 'styled-components'
import { tabletBreakpoint, desktopBreakpoint, wideScreenBreakpoint } from 'react-components'
import { CarouselProvider, Slider, Slide } from 'pure-react-carousel'

export const Container = styled.section(
    ({ theme }) => css`
        width: inherit;
        padding: 1rem 0 0.5rem;
        overflow: hidden;

        @media only screen and (min-width: ${tabletBreakpoint.min}px) {
            padding: 2rem 0 1rem;
        }

        @media only screen and (min-width: ${desktopBreakpoint.min}px) {
            padding: 2rem 1.5rem 1rem;
        }

        @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
            padding: 2rem 4rem 1rem;
        }
    `,
)

export const InnerContainer = styled.div`
    margin-top: 1rem;

    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        margin-top: 0.5rem;
    }
`

export const StyledSlider = styled(Slider)<{ $stopSliderTransition?: boolean }>(
    ({ $stopSliderTransition, theme }) => css`
        padding: 0;
        ul {
            transition: transform 0.5s;
            transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1);
            will-change: transform;
            min-width: ${theme.layout.fill};
        }

        ${$stopSliderTransition &&
        `ul {
            transition: none !important;
            }
        `}
    `,
)

export const StyledCarouselProvider = styled(CarouselProvider)(
    ({ theme }) => css`
        width: 100%;

        li {
            list-style: none;
        }

        & > .carousel__slider {
            padding: 0 1rem;

            & :last-child {
                padding-right: 0;
            }

            @media only screen and (min-width: ${tabletBreakpoint.min}px) {
                padding: 0 1.5rem;
            }

            @media only screen and (min-width: ${desktopBreakpoint.min}px) {
                padding-left: 0;
                padding-right: 0;
            }
        }
    `,
)

export const StyledSlide = styled(Slide)(
    ({ theme }) => css`
        > div:first-child {
            height: 100%;
        }
    `,
)

export const DestinationContainer = styled.div`
    display: flex;
`
